import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DominiosComponent } from './dominios/dominios.component';
import { AgentesComponent } from './agentes/agentes.component';
import { RolesComponent } from './roles/roles.component';
import { BaseConocimientoComponent } from './base-conocimiento/base-conocimiento.component';
import { BotComponent } from './bot/bot.component';
import { QuestionCrudComponent } from './question-crud/question-crud.component';
import { AdminMasComponent } from './admin-mas/admin-mas.component';
import { ChatComponent } from './chat/chat.component';
import { IntroJustinoComponent } from './intro-justino/intro-justino.component';
import { EncuestaComponent } from './encuesta/encuesta.component';
import { GestionVideosComponent } from './gestion-videos/gestion-videos.component';
import { GestionFuncionalidadesComponent } from './gestion-funcionalidades/gestion-funcionalidades.component';
import { GestionInformacionComponent } from './gestion-informacion/gestion-informacion.component';
import { TimelineComponent } from './timeline/timeline.component';
import { ConsentimientoComponent } from './consentimiento/consentimiento.component';

const routes: Routes = [
  {
    path: '',
    data: { breadcrumb: 'miga-pan.administrador' },
    children: [
      {
        path: '',
        component: AdminMasComponent,
        data: { breadcrumb: 'miga-pan.administrador' },
      },
      {
        path: 'agentes',
        component: AgentesComponent,
        data: { breadcrumb: 'miga-pan.panel-control' },
      },
      {
        path: 'dominios/:idDominio',
        component: DominiosComponent,
        data: { breadcrumb: 'miga-pan.dominios' },
      },
      {
        path: 'roles',
        component: RolesComponent,
        data: { breadcrumb: 'miga-pan.roles' },
      },
      {
        path: 'bases-conocimiento',
        component: BaseConocimientoComponent,
        data: { breadcrumb: 'miga-pan.bases-conocimiento' },
      },
      {
        path: 'bot',
        component: BotComponent,
        data: { breadcrumb: 'miga-pan.bot' },
      },
      {
        path: 'preguntas',
        component: QuestionCrudComponent,
        data: { breadcrumb: 'miga-pan.editor-encuesta' },
      },
      {
        path: 'encuesta',
        component: EncuestaComponent,
        data: { breadcrumb: 'miga-pan.editor-encuesta' },
      },
      {
        path: 'gestion-videos',
        component: GestionVideosComponent,
        data: { breadcrumb: 'miga-pan.videos' },
      },
      {
        path: 'gestion-funcionalidades',
        component: GestionFuncionalidadesComponent,
        data: { breadcrumb: 'miga-pan.funcionalidades' },
      },
      {
        path: 'gestion-documentos/:idEntidad',
        component: GestionInformacionComponent,
        data: { breadcrumb: 'miga-pan.informacion' },
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JustinoRoutingModule {}
